/* global femcare */

/**
 * Custom and "hacky" watchers to enable GA tracking on the Azure sign up pages.
 * Since we don't have any control of the pages we need to add the GA-event triggers here.
 */
femcare.azure.gaTracking = {
    init: function () {
        if ($('.azure-auth').length) {
            // Watch if sign up verification is sent.
            $('#email_ver_input').attrchange({
                trackValues: true,
                callback: function (e) {
                    if (e.newValue.match('inline')) {
                        // let's bring these back when we got a better way to track it
                        // currently this gets triggered upon verification error as well, which is no good /Stefan
                        // $(document).trigger('ga-userSignUpVerificationSent');
                    }
                }
            });

            // Watch if sign up verification succeed.
            $('#email_ver_but_edit').attrchange({
                trackValues: true,
                callback: function (e) {
                    if (e.newValue.match('inline')) {
                        // $(document).trigger('ga-userSignUpVerificationSuccessful');
                    }
                }
            });

            // Watch if sign in fails.
            $('.localAccount .error').attrchange({
                trackValues: true,
                callback: function (e) {
                    var errorMessage = $(e.target)
                        .find('p')
                        .html();

                    if (e.newValue.match('block')) {
                        $(document).trigger('ga-userLogInFailure', [errorMessage]);
                    }
                }
            });

            // Cancel sign up
            $('#cancel').on('click', function () {
                $(document).trigger('ga-userSignUpCancel');
            });

            // Azure sign up start
            $('#createAccount').on('click', function () {
                $(document).trigger('ga-userSignUpStarted');
            });

            // Facebook sign up start
            $('#FacebookExchange').on('click', function () {
                $(document).trigger('ga-userSignUpStartedFacebook');
            });
        }
    }
};
